<nav class="breadcrumb" aria-label="Breadcrumb navigation">
  <ol class="breadcrumb-list">
    <li
      *ngFor="let item of getVisibleItems(); let i = index; let last = last"
      class="breadcrumb-item"
      [class.active]="last"
      [class.disabled]="item.disabled">

      <!-- Ícone do item -->
      <mat-icon
        *ngIf="showIcons && item.icon"
        class="breadcrumb-icon">
        {{ item.icon }}
      </mat-icon>

      <!-- Link ou texto do item -->
      <a
        *ngIf="!last && item.url && !item.disabled"
        [routerLink]="item.url"
        [queryParams]="item.queryParams"
        class="breadcrumb-link"
        (click)="onItemClick(item, i)">
        {{ item.label }}
      </a>

      <span
        *ngIf="last || !item.url || item.disabled"
        class="breadcrumb-text"
        [class.current]="last">
        {{ item.label }}
      </span>

      <!-- Separador -->
      <span
        *ngIf="!last"
        class="breadcrumb-separator">
        <!-- Ícone Bootstrap quando useChevronIcon é true -->
        <i *ngIf="useChevronIcon" class="bi bi bi-chevron-right"></i>
        <!-- Texto separador quando useChevronIcon é false -->
        <span *ngIf="!useChevronIcon">{{ separator }}</span>
      </span>
    </li>

    <!-- Indicador de mais itens -->
    <li
      *ngIf="isEllipsisNeeded()"
      class="breadcrumb-ellipsis">
      <span class="breadcrumb-ellipsis-text">...</span>
    </li>
  </ol>
</nav>
